import isGHMC, {
  getCurrentDate,
  getCurrentDateTime,
  getFirstDateOfMonth,
  getStartOfCurrentDate,
  getStartOfCurrentDate1,
} from "../../../../Common/helper/helpar";
import { Formik, Form, Field } from "formik";
import { useMonthWiseAttendanceStore } from "../../Attendance/MonthWiseAttendanceSummary/MonthWiseAttendanceStore";
import { useEffect, useState } from "react";
import { GetCircle, GetZone } from "../../../../Apis/organizationApi";
import { GetOperations, GetDesignations } from "../../../../Apis/operationApi";
// import { MonthWiseAttendanceExport } from "./MonthWiseAttendanceExport";
import { getAllTransferStationMaster } from "../../../../Apis/transferStationApi";
import { HygieneTransportationExport } from "./HygieneReportExport";
import HygienicTransportationStore from "./store/HygieneStore";
import {
  getNowDateTime,
  getOneMonthPastDate,
  getOneMonthPastDateTime,
  getTodayDate,
} from "../../../AssetVehicle/utils/helpers";

export const HygieneTransportationFilter = () => {
  const { loading, hygienicReportData, fetchHygienicTransportationReport } =
    HygienicTransportationStore();
  const isProd = isGHMC();

  const currentDate = getStartOfCurrentDate1(); // your new function

  const defaultValues = {
    FromDate: currentDate,
    ToDate: currentDate,
  };

  const handleSubmit = (values) => {
    localStorage.setItem(
      "hygieneTransportationFilters",
      JSON.stringify(values),
    );
    fetchHygienicTransportationReport(values);
  };

  useEffect(() => {
    localStorage.setItem(
      "hygieneTransportationFilters",
      JSON.stringify(defaultValues),
    );
    fetchHygienicTransportationReport(defaultValues);
  }, []);

  const handleReset = (resetForm) => {
    resetForm();
    localStorage.setItem(
      "hygieneTransportationFilters",
      JSON.stringify(defaultValues),
    );
    fetchHygienicTransportationReport(defaultValues);
  };

  return (
    <>
      <Formik initialValues={defaultValues} onSubmit={handleSubmit}>
        {({ values, setFieldValue, resetForm }) => (
          <Form>
            <div className="d-flex justify-content-between align-items-center mt-3">
              <div className="d-flex align-items-end gap-2 mb-2">
                <div style={{ width: "200px" }}>
                  <div className="form-group-filter">
                    <label className="form-label w-100 text-left">
                      From Date
                    </label>
                    <Field
                      type="date"
                      id="FromDate"
                      value={values.FromDate}
                      name="FromDate"
                      className="form-control bg-white"
                      min={getOneMonthPastDate()}
                      max={currentDate}
                    />
                  </div>
                </div>
                <div style={{ width: "200px" }}>
                  <div className="form-group-filter">
                    <label className="form-label w-100 text-left">
                      To Date
                    </label>
                    <Field
                      type="date"
                      id="ToDate"
                      name="ToDate"
                      value={values.ToDate}
                      className="form-control bg-white"
                      max={currentDate}
                      required
                    />
                  </div>
                </div>
                {/* <div className="col-md-3 d-flex gap-2 align-items-end "> */}
                <button
                  type="submit"
                  className={`btn w-90 ${isProd ? "search-ghmc" : "search-swm"}`}
                >
                  Search
                </button>
                {/* <button
                  type="reset"
                  className={`btn w-90 ${isProd ? "search-ghmc" : "search-swm"}`}
                  onClick={() => handleReset(resetForm)}
                >
                  Reset
                </button> */}

                {/* </div> */}
              </div>
              <div className="mt-4 d-flex">
                <HygieneTransportationExport
                  fromDate={values.FromDate}
                  toDate={values.ToDate}
                />
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};
